import script from "./DashboardStatusBlock.vue?vue&type=script&lang=ts"
export * from "./DashboardStatusBlock.vue?vue&type=script&lang=ts"

const __exports__ = script;

export default __exports__